import React from 'react'

import { css } from '@emotion/core'
import Relazsizes from 'relazsizes'

const KoinworksBanner = () => (
  <div className="koinworks-banner">
    <Relazsizes
      alt="Koinworks"
      el="picture"
      dataSrcset={[
        {
          media: '(min-width: 576px)',
          srcset: '/next-assets/images/koinworks/banner-pc.jpg',
          alt: 'Koinworks',
        },
      ]}
      dataSrc="/next-assets/images/koinworks/banner-sp.jpg"
      css={css`
        width: 100%;
      `}
    />
  </div>
)

export default KoinworksBanner
